<template>
  <div class="row">
    <div class="col-12">
      <f-data-table id="clips_table" :expanded="true"
                    heading="Clips"
                    icon="la la-scissors"
                    :data-uri="clips_url"
                    :columns="columns"
                    :selectable-rows="false"
                    :server-side="true">
        <template #from="props">
          {{ props.value | formatFromTo }}
        </template>

        <template #to="props">
          {{ props.value | formatFromTo }}
        </template>

        <template #created_at="props">
          <span>{{ formatDateTime(props.value) }}</span>
        </template>

        <template #actions="props">
          <div class="row-action-cell">
            <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-clean btn-icon"
                      data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                <i class="flaticon-more-1" />
              </button>
              <div class="dropdown-menu dropdown-menu-right" style="">
                <ul class="kt-nav">
                  <li class="kt-nav__item">
                    <a href="javascript:;" class="kt-nav__link" @click="props.do({ cb: convertClipsToStorage, reload_data: true})">
                      <i class="kt-nav__link-icon la la-exchange" />
                      <span class="kt-nav__link-text">Convert to Storage</span>
                    </a>
                  </li>
                  <li class="kt-nav__item">
                    <a href="javascript:;" class="kt-nav__link" @click="() => initQuickCreateModal(props.row)">
                      <i class="kt-nav__link-icon la la-exchange" />
                      <span class="kt-nav__link-text">Convert to Item</span>
                    </a>
                  </li>
                  <li class="kt-nav__item">
                    <a href="javascript:;" class="kt-nav__link" @click="listen(props.row)">
                      <i class="kt-nav__link-icon flaticon2-speaker" />
                      <span class="kt-nav__link-text">Listen</span>
                    </a>
                  </li>
                  <li v-perms="['api.clip.mass-destroy']" class="kt-nav__item">
                    <a href="javascript:;" class="kt-nav__link" @click="props.do({ cb: deleteClips, reload_data: true})">
                      <i class="kt-nav__link-icon flaticon2-trash" />
                      <span class="kt-nav__link-text">Delete</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </f-data-table>
    </div>

    <simple-html5-player v-if="listen_file_path" :file-path="listen_file_path"
                         :bottom-fixed="true" @close-request="() => listen_file_path = ``" />

    <vjs-modal :name="`item-create-modal`"
               :title="`Convert to ${getItemLabel(true)}`"
               icon="la la-plus-circle">
      <item-creation-form v-if="quick_create_asset" :is-clip="true" :preselected-storage-asset="quick_create_asset" />
    </vjs-modal>
  </div>
</template>

<script>
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable";
import SimpleHtml5Player from "VueComponents/SimpleHtml5Player";
import { convertToHhmmss } from "Helpers/formatters";
import ItemQuickCreateMixin from "VueMixins/ItemQuickCreateMixin";
import VjsModal from "VueModals/VjsModal";
import ItemCreationForm from "VueComponents/ItemCreation/Form.vue";

export default {
  components: { FDataTable, SimpleHtml5Player, VjsModal, ItemCreationForm },
  filters: {
    formatFromTo: function (value) {
      return convertToHhmmss(value);
    },
  },
  mixins: [ItemQuickCreateMixin],
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      listen_file_path: ``,
      columns: [
        {
          display: "Name",
          field: "name",
          never_clip: true,
        },
        {
          display: "From",
          field: "from",
          sortable: true,
        },
        {
          display: "To",
          field: "to",
          sortable: true,
        },
        {
          display: "Created At",
          field: "created_at",
          sortable: true,
        },
        {
          field: `actions`,
          display: ``,
          sortable: false,
          width: 150,
          never_clip: true,
        },
      ],
    };
  },
  computed: {
    clips_url() {
      if (this.item.uuid) {
        return `/api/v1/storage/${this.item.uuid}/clips`;
      }
      return null;
    },
  },
  methods: {
    listen(clip) {
      this.listen_file_path = `${window.public_media_path}clips/${clip.name}`;
    },
    async convertClipsToStorage(...clips) {
      try {
        (await axios.post(`/api/v1/clip/convert-to-storage`, {
          clip_uuids: clips.map(clip => clip.uuid).join(`,`),
        })).data;

        window.EventBus.$emit('clips_table-reload');
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    async deleteClips(...clips) {
      try {
        (await axios.delete(`/api/v1/clip/massDelete`, {
          params: { clip_uuids: clips.map(clip => clip.uuid).join(`,`) },
        })).data;
        toastr.success("Clip(s) Deleted");
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
  },
};
</script>
